import { DashboardRouteParams } from '@/types';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

export function usePlaceSpecificUrl() {
  const { region } = useParams<DashboardRouteParams>();

  const getPlaceSpecificUrl = useCallback(
    (path: string) => {
      if (!region) {
        throw new Error(
          'region is required. Ensure URL has a region param and route definition includes a region param, e.g. /ca-placer/home for /:region/home'
        );
      }

      return `/${region}/${path}`;
    },
    [region]
  );

  return { getPlaceSpecificUrl };
}
